<template>
  <Modal v-model="iossRuleModal" :title="iossRuleTitle" width="500"
    :transfer="false" :mask-closable="false" @on-visible-change="iossRuleChange">
    <Form ref="iossRuleForm" :model="iossRuleForm" :rules="ruleValidate" :label-width="labelWidth" @submit.native.prevent>
      <Row style="width: 90%">
        <Col :xxl="oneItemCol" :xl="oneItemCol" :lg="oneItemCol" :md="oneItemCol">
          <Form-item :label="$t('key1001437')" prop="name">
            <Input clearable v-model.trim="iossRuleForm.name"/>
            <span class="font-size-12">{{ $t('key1005446') }}</span>
          </Form-item>
        </Col>
        <Col :xxl="oneItemCol" :xl="oneItemCol" :lg="oneItemCol" :md="oneItemCol">
          <Form-item :label="$t('key1005442')" prop="ymsIossId">
            <Select v-model="iossRuleForm.ymsIossId" filterable transfer :placeholder="$t('key1000101')">
              <Option v-for="item in iossList" :value="item.ymsIossId">{{ item.name }}</Option>
            </Select>
          </Form-item>
        </Col>
        <Col :xxl="oneItemCol" :xl="oneItemCol" :lg="oneItemCol" :md="oneItemCol">
          <Form-item :label="$t('key1005443')" prop="type" class="radio_styles_distributor">
            <RadioGroup v-model="iossRuleForm.type">
              <Radio :label="1">{{ $t('key1005447') }}</Radio>
              <Radio :label="2">{{ $t('key1005448') }}</Radio>
            </RadioGroup>
          </Form-item>
        </Col>
        <Col :xxl="oneItemCol" :xl="oneItemCol" :lg="oneItemCol" :md="oneItemCol" v-if="iossRuleForm.type === 2">
          <Form-item :label="$t('key1005444')" prop="platformIds">
            <Select v-model="iossRuleForm.platformIds" multiple filterable transfer :placeholder="$t('key1000101')">
              <Option v-for="item in platformList" :value="item.platformId">{{ item.name }}</Option>
            </Select>
          </Form-item>
        </Col>
        <Col :xxl="oneItemCol" :xl="oneItemCol" :lg="oneItemCol" :md="oneItemCol" v-else>
          <Form-item :label="$t('key1005445')" prop="shopIds">
            <Select v-model="iossRuleForm.shopIds" multiple filterable transfer :placeholder="$t('key1000101')">
              <Option v-for="item in storeAllList" :value="item.storeId">{{ item.storeName }}</Option>
            </Select>
          </Form-item>
        </Col>
      </Row>
    </Form>
    <template #footer>
      <Button @click="iossRuleModal = false">{{ $t('key1000112') }}</Button>
      <Button type="primary" @click="iossRuleBtn">{{ $t('key1000555') }}</Button>
    </template>
  </Modal>
</template>

<script>
import aliasb03645cf6abd4d56a73b13687765a5d8 from '@/locale/i18nUtils.js';

import api from '@/api/';
import Mixin from "@/components/mixin/common_mixin";

export default {
  name: "iossRuleModal",
  mixins: [Mixin],
  props: {
    //所有店铺数据
    storeAllList: {
      type: Array,
      default: () => []
    },
    // 平台数据
    platformList: {
      type: Array,
      default: () => []
    }
  },
  data() {
    let v = this;
    return {
      iossRuleModal: false,
      iossRuleTitle: '',
      iossRuleForm: {
        name: '',
        ymsIossId: null,
        type: 1,
        platformIds: [],
        shopIds: []
      },
      ruleValidate: {
        name: [
          {required: true, message: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1001334'), trigger: 'blur'}
        ],
        platformIds: [
          {type: 'array', required: true, message: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1001347'), trigger: 'change'},
        ],
        ymsIossId: [
          {required: true, message: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1005439'), trigger: 'change'},
        ],
        shopIds: [
          {type: 'array', required: true, message: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1005440'), trigger: 'change'},
        ],
      },
      iossRuleType: 'add',
      autoRuleId: null,
      iossList: [],
      iossRulesInfo: {},
    };
  },
  methods: {
    // 初始化数据
    initIossRuleData(type, data) {
      let v = this;
      v.iossRuleType = type;
      let obj = {
        add: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1005441'),
        edit: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1002169')
      };
      v.iossRuleTitle = obj[type];
      if (type === 'edit') {
        v.autoRuleId = data.autoRuleId;
        v.getIossRulesData(data);
      }
      (async () => {
        await v.getEnableIossData();
      })();
      v.iossRuleModal = true;
    },
    // 获取规则详情数据
    getIossRulesData(data) {
      let v = this;
      if (data) {
        v.iossRulesInfo = data;
        v.iossRuleForm.name = data.name;
        v.autoRuleId = data.autoRuleId;
        let ruleActions = data.ruleActions || [];
        let ruleItems = data.ruleItems || [];
        if (ruleActions.length > 0) {
          ruleActions.map((ele) => {
            if (ele.type === 'IOSS_CONFIG_RULE') {
              let obj = JSON.parse(ele.value);
              v.iossRuleForm.ymsIossId = obj.ymsIossId;
            }
          });
        }
        if (ruleItems.length > 0) {
          ruleItems.map((ele) => {
            if (ele.ruleCode === 'IOSS_CONFIG_RULE') {
              let ruleItemParams = ele.ruleItemParams || [];
              if (ruleItemParams.length > 0) {
                let ruleItemParamValues = ruleItemParams[0].ruleItemParamValues || [];
                let name = ruleItemParams[0].name;
                v.iossRuleForm.type = name === 'shopIds' ? 1 : 2;
                if (ruleItemParamValues.length > 0) {
                  ruleItemParamValues.map((talg) => {
                    let obj = JSON.parse(talg.value);
                    // 店铺
                    if (name === 'shopIds') {
                      let id = obj.platformId + '-' + obj.shopId;
                      v.iossRuleForm.shopIds.push(id);
                    }
                    // 平台
                    else {
                      v.iossRuleForm.platformIds.push(obj.platformId);
                    }
                  });
                }
              }
            }
          });
        }
      }
    },
    // 保存
    iossRuleBtn() {
      let v = this;
      let query = {};
      let url = '';
      let method = '';
      let text = '';
      let obj = {};
      switch (v.iossRuleForm.type) {
        // 店铺
        case 1:
          obj = {
            name: 'shopIds',
            type: v.iossRuleForm.type,
            autoRuleParamValues: []
          };
          let shopIdsList = v.iossRuleForm.shopIds;
          if (shopIdsList.length > 0) {
            shopIdsList.map((item) => {
              let list = item.split('-');
              obj.autoRuleParamValues.push({value: JSON.stringify({platformId: list[0], shopId: list[1]})});
            });
          }
          break;
        // 平台
        case 2:
          obj = {
            name: 'platformIds',
            type: v.iossRuleForm.type,
            autoRuleParamValues: []
          };
          let platformIdsList = v.iossRuleForm.platformIds;
          if (platformIdsList.length > 0) {
            platformIdsList.map((item) => {
              obj.autoRuleParamValues.push({value: JSON.stringify({platformId: item})});
            });
          }
          break;
      }
      query = {
        autoRuleActions: [
          {
            type: 'IOSS_CONFIG_RULE',
            value: JSON.stringify({ymsIossId: v.iossRuleForm.ymsIossId})
          }
        ],
        autoRuleItems: [
          {
            autoRuleParams: [obj],
            ruleCode: 'IOSS_CONFIG_RULE'
          }
        ],
        name: v.iossRuleForm.name
      };
      if (v.iossRuleType === 'add') {
        query.status = 1; // 新增的时候，默认为启用状态
        url = api.post_ymsIossRule_insert;
        method = 'post';
        text = aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000113');
      } else {
        url = api.put_ymsIossRule;
        method = 'put';
        text = aliasb03645cf6abd4d56a73b13687765a5d8.t('key1002161');
        query.autoRuleId = v.autoRuleId;
        query.type = 'IOSS_CONFIG_RULE';
        query.status = v.iossRulesInfo.status;
      }
      v.$refs['iossRuleForm'].validate((valid) => {
        if (valid) {
          v.axios[method](url, query, {loading: true, loadingText: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000247')}).then(response => {
            if (response.data.code === 0) {
              v.iossRuleModal = false;
              v.$Message.success(text);
              v.$emit('updateData', true);
            }
          });
        }
      });
    },
    // 获取启用的IOSS
    getEnableIossData() {
      let v = this;
      v.axios.get(api.get_ymsIoss_queryEnable).then(response => {
        if (response.data.code === 0) {
          let data = response.data.datas || [];
          v.iossList = data;
        }
      });
    },
    // 监听弹窗
    iossRuleChange(val) {
      if (!val) {
        this.iossRulesInfo = {};
        this.$refs['iossRuleForm'].resetFields();
      }
    }
  }
};
</script>

<style lang="less" scoped>

</style>